import send from "../default-icons/send";
import loading from "../default-icons/loading";
import error from "../default-icons/error";
export default { send, loading, error };
